import { ColumnDef } from "@tanstack/react-table";
import { useForm, useWatch } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import APIS from "../../constant/Endpoint";
import DataTable from "../Reusable/Datatable";
import NACell from "../Reusable/Datatable/NACell";
import Filter from "./Filter";
import { useDownload } from "@careinfo/layout";
import { tw } from "@careinfo/tailwind";
import moment from "moment";
import Button from "../Reusable/Button";

const StockTrial = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const startOfMonth = moment().startOf("month").format("YYYY-MM-DD");
  const endOfMonth = moment().endOf("month").format("YYYY-MM-DD");
  const { download } = useDownload();
  const {
    control,
    register,
    getValues,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm<any>({
    defaultValues: {
      account: searchParams.get("account") || "",
      user: searchParams.get("user") || "",
      created: searchParams.get("created") || "",
      created__range: `${startOfMonth},${endOfMonth}`,
    },
  });
  const formValues = useWatch({ control });
  const columns: ColumnDef<any, any>[] = [
    {
      accessorKey: "account.name",
      header: "Product Name",
      cell: NACell,
    },
    {
      accessorKey: "account.unit.name",
      header: "Unit",
      cell: NACell,
    },
    {
      accessorKey: "account.opening_quantity",
      header: "Opening Quantity",
      cell: NACell,
    },
    {
      accessorKey: "quantity",
      header: "Received",
      cell: ({ row, getValue }: any) => (
        <p>{row.original.is_sales ? "" : getValue()}</p>
      ),
    },
    {
      accessorKey: "quantity",
      header: "Issued",
      cell: ({ row, getValue }: any) => (
        <p>{row.original.is_sales ? getValue() : ""}</p>
      ),
    },
    {
      accessorKey: "closing_quantity",
      header: "Closing Quantity",
      cell: ({ row, getValue }: any) => {
        return <p>{getValue() ?? 0}</p>;
      },
    },
  ];
  const handleDownloadExcel = async () => {
    try {
      const cleanedParams = Object.fromEntries(
        Object.entries(formValues)
          .filter(
            ([, value]) => value !== null && value !== undefined && value !== ""
          )
          .map(([key, value]) => [key, String(value)])
      );

      const queryString = new URLSearchParams(cleanedParams).toString();

      await download(
        `${APIS.PRODUCT}stock-trial-excel-download/?${queryString}`,
        `stock-valuation-${moment().format("MMMM-Do-YYYY-h-mm-ss")}.xlsx`
      );
    } catch (e) {
      console.error(e);
    }
  };
  return (
    <>
      <Filter
        register={register}
        errors={errors}
        setValue={setValue}
        getValues={getValues}
        clearErrors={clearErrors}
      />
      <div className={tw`flex justify-end mb-2`}>
        <div className={tw`w-24`}>
          <Button label="Download" onClick={() => handleDownloadExcel()} />
        </div>
      </div>
      <DataTable
        columns={columns}
        queryKey={"stock-trial-normal"}
        url={`${APIS.PRODUCT}items/`}
        params={formValues}
        customSearch={true}
        tableName="stock-trial-normal"
      />
    </>
  );
};

export default StockTrial;

